import { useToast } from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

const $toast = useToast()

// Custom toast styles
const customStyles = {
  success: {
    color: '#155724',
    backgroundColor: '#d4edda',
    borderColor: '#c3e6cb',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
  },
  error: {
    color: '#721c24',
    backgroundColor: '#f8d7da',
    borderColor: '#f5c6cb',
    boxShadow: '0 4px 12px rgba(220, 53, 69, 0.2)'
  },
  warning: {
    color: '#856404',
    backgroundColor: '#fff3cd',
    borderColor: '#ffeeba',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
  },
  info: {
    color: '#0c5460',
    backgroundColor: '#d1ecf1',
    borderColor: '#bee5eb',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
  }
}

const alert = {
  success: (message, duration = 7000) => {
    $toast.open({
      message: message,
      type: 'success',
      position: 'top-right',
      duration: duration,
      dismissible: true,
      pauseOnHover: true,
      onClick: () => $toast.clear(),
      containerClassName: 'toast-container',
      customStyle: customStyles.success
    })
  },
  error: (message, duration = 10000) => {
    $toast.open({
      message: message,
      type: 'error',
      position: 'top-right',
      duration: duration,
      dismissible: true,
      pauseOnHover: true,
      onClick: () => $toast.clear(),
      containerClassName: 'toast-container',
      customStyle: customStyles.error
    })
  },
  warning: (message, duration = 7000) => {
    $toast.open({
      message: message,
      type: 'warning',
      position: 'top-right',
      duration: duration,
      dismissible: true,
      pauseOnHover: true,
      onClick: () => $toast.clear(),
      containerClassName: 'toast-container',
      customStyle: customStyles.warning
    })
  },
  info: (message, duration = 7000) => {
    $toast.open({
      message: message,
      type: 'info',
      position: 'top-right',
      duration: duration,
      dismissible: true,
      pauseOnHover: true,
      onClick: () => $toast.clear(),
      containerClassName: 'toast-container',
      customStyle: customStyles.info
    })
  },
  default: (message, duration = 7000) => {
    $toast.open({
      message: message,
      position: 'top-right',
      duration: duration,
      dismissible: true,
      pauseOnHover: true,
      onClick: () => $toast.clear(),
      containerClassName: 'toast-container'
    })
  },
}

export default {
  alert,
}
